<template>
  <div>
      <b-card title="Configuration">
            <b-container>
                <b-row class="mb-3">
                    <b-col sm="1" class="d-flex align-items-center">
                        <label for="username" class="h5 font-weight-normal">Username</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-input

                            id="username"
                            placeholder="Username"
                            v-model="username"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="1" class="d-flex align-items-center">
                        <label for="password" class="h5 font-weight-normal">Password</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-input

                            id="password"
                            placeholder="Password"
                            v-model="password"
                        />
                    </b-col>
                </b-row>
            </b-container>
        
        <b-row class="justify-content-end pr-2" >
                <b-button 
                    variant="outline-secondary"
                    @click="$router.back()"
                >
                    Cancel
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click="update()"
                >
                    Save
                </b-button>
        </b-row>
      </b-card>
  </div>
</template>

<script>
import { BLink, BImg, BContainer, BRow, BCol, BCard, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BFormTextarea } from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        BLink,
        BImg,
        BCol,
        BContainer,
        BRow,
        BCard,
        BProgress,
        BCardText,
        BDropdown,
        BDropdownItem,
        BButton,
        BFormGroup,
        BFormInput,
        quillEditor,
        BFormTextarea
    },
    data() {
        return {
            username: '',
            password: '',
            updated_at: '',
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            return await this.$http.get(`/ldap-conf`)
            .then( res => {
                let data = res.data.data
                this.username = data.username
                this.updated_at = data.updated_at
            })
        },
       async update() {
            let fd = new FormData();
            fd.append('username', this.username)
            fd.append('password', this.password)
            let conf = {
                ...this.$store.getters['app/axiosConf'],
                url: `/ldap-conf`,
                data: fd
            }
            return await this.$http(conf)
            .then(res => {
                this.$notif('Success', 'Configuration has been successfully updated.', 'success')
            })
            .catch(err => {
                this.$notif('Something Error', err.data.errors[Object.keys(err.data.errors)[0]][0], 'danger')
            })
        },
    }
}
</script>

<style scoped>

/deep/ .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
/deep/ .dz-size {
    display: none;
}
/deep/ .dropzone .dz-preview .dz-error-message {
    top: 150px!important;
}
</style>